import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

interface StyledEditableFieldButtonProps {
  isConfirm?: boolean;
  isHidden?: boolean;
}
export const EditableFieldButton = styled.button<StyledEditableFieldButtonProps>`
  width: 32px;
  visibility: ${({ isHidden }) => (isHidden ? 'hidden' : 'visible')};
  height: 32px;
  min-width: 32px;
  margin-left: 8px;
  z-index: 1000;

  background: ${({ isConfirm }) =>
    isConfirm ? beam.color.primaryBlue : beam.color.pureWhite};
  border: none;
  /* small-shadow */
  box-shadow: ${({ isConfirm }) =>
    isConfirm
      ? '0 1px 4px rgba(19, 113, 254, 0.7)'
      : '0 1px 4px rgba(0, 0, 0, 0.161)'};
  border-radius: 8px;
`;

export const FlexRowContainer = styled.div`
  /* Layout Properties */
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-content: center;
  align-items: center;
  width: 100%;
`;

export const Icon = styled.img<StyledEditableFieldButtonProps>`
  color: ${({ isConfirm }) =>
    isConfirm ? beam.color.pureWhite : beam.color.pureBlack};
`;
interface StyledEditableFieldButtonProps {
  isHidden?: boolean;
  isNotDate?: boolean;
}
export const Container = styled.div<StyledEditableFieldButtonProps>`
  display: flex;
  align-items: center;
  width: ${({ isHidden }) => (isHidden ? '16vw' : '16vw')};
  padding: 4px 8px;
  border-radius: 4px;
  overflow: ${({ isHidden }) => (isHidden ? 'hidden' : 'unset')};
  :hover {
    background: ${({ isHidden }) => (isHidden ? '#e9edf1' : 'transparent')};
    & nav {
      color: ${beam.font.primary};
      cursor: pointer;
    }
  }
`;
export const ContainerSidebar = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  width: 100%;
`;

interface BlackIconProps {
  isHidden?: boolean;
}
export const BlackIcon = styled.nav<BlackIconProps>`
  display: flex;
  position: absolute;
  right: -8px;
  align-items: center;
  visibility: ${({ isHidden }) => (isHidden ? 'hidden' : 'unset')};
  font-style: normal;
  text-align: center;
  justify-content: center;
  cursor: auto;
  font-weight: 900;
  font-size: 12px;
  line-height: 14px;
  z-index: 999;

  /* beam-colors/beam-accent */
  color: transparent;
`;
